import { useEffect } from "react";
import { useLang } from "../i18n";

const SEO = {
  es: {
    title: "Alquiler de Motos en Tenerife | Rent a Moto Topacio",
    desc: "Alquiler de scooters y motos trail en Tenerife Sur desde 39€/día. Seguro, casco e impuestos incluidos. Reserva online en Costa Adeje.",
  },
  en: {
    title: "Motorcycle Rental Tenerife | Rent a Moto Topacio",
    desc: "Scooter & motorbike rental in South Tenerife from €39/day. Insurance, helmet and taxes included. Book online in Costa Adeje.",
  },
  de: {
    title: "Motorradvermietung Teneriffa | Rent a Moto Topacio",
    desc: "Roller- & Motorradvermietung im Süden Teneriffas ab 39€/Tag. Versicherung, Helm und Steuern inklusive. Online buchen in Costa Adeje.",
  },
  it: {
    title: "Noleggio Moto Tenerife | Rent a Moto Topacio",
    desc: "Noleggio scooter e moto trail a Tenerife Sud da 39€/giorno. Assicurazione, casco e tasse inclusi. Prenota online a Costa Adeje.",
  },
};

export default function Seo() {
  const { lang } = useLang();
  useEffect(() => {
    const m = SEO[lang] || SEO.es;
    document.documentElement.lang = lang;
    document.title = m.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", m.desc);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", m.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", m.desc);
  }, [lang]);
  return null;
}
